import { render } from "./detalleContratante.vue?vue&type=template&id=29678a96&scoped=true"
import script from "./detalleContratante.vue?vue&type=script&lang=js"
export * from "./detalleContratante.vue?vue&type=script&lang=js"

import "./detalleContratante.vue?vue&type=style&index=0&id=29678a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29678a96"]])

export default __exports__